export default function getQuizIdFromUrlHash() {
    if (window.location.hash) {
        const hash = window.location.hash;
        if (hash.startsWith('#trivia-quiz-')) {
            const quizId = parseInt(hash.split('-')[2], 10); // 3rd item in: #trivia-quiz-1234
            return isNaN(quizId) ? 0 : quizId;
        }
    }
    return 0;
}
